<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Késések</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Késések</ion-card-title>
      <ion-card-subtitle>
        A napló névsorában rögzített percek. A rendszer ezekből számolja az órákat:
        <b>{{ percEgyOra }} összegyűlt igazolatlan perc = 1 igazolatlan óra</b>. Igazoláskor a percek
        az igazolt oldalra kerülnek át – nincs külön mulasztás-tétel, amit javítani kellene.
        Az osztályfőnök a saját osztálya tanulóinak minden késését látja és igazolhatja; a pedagógus a tanított
        tanulóiét látja, és a saját óráin rögzítetteket kezeli.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div class="ks-fejlec">
        <ion-select label="Tanév" label-placement="stacked" interface="popover" fill="outline"
                    [(ngModel)]="tanev" (ionChange)="betolt()">
          <ion-select-option *ngFor="let e of tanevek" [value]="e">{{ e }}/{{ e + 1 }}</ion-select-option>
        </ion-select>
        <ion-select label="Állapot" label-placement="stacked" interface="popover" fill="outline"
                    [(ngModel)]="allapot" (ionChange)="betolt()">
          <ion-select-option value="mind">Mind</ion-select-option>
          <ion-select-option value="igazolatlan">Csak igazolatlan</ion-select-option>
          <ion-select-option value="igazolt">Csak igazolt</ion-select-option>
        </ion-select>
        <ion-input label="Dátumtól" label-placement="stacked" fill="outline" type="date"
                   [(ngModel)]="tol" (ionChange)="betolt()"></ion-input>
        <ion-input label="Dátumig" label-placement="stacked" fill="outline" type="date"
                   [(ngModel)]="ig" (ionChange)="betolt()"></ion-input>
        <ion-input label="Keresés" label-placement="stacked" fill="outline"
                   placeholder="tanuló, osztály, tantárgy" [(ngModel)]="szuro"></ion-input>
      </div>

      <div class="ks-allapot" *ngIf="toltodik">
        <ion-spinner name="dots"></ion-spinner><span>Betöltés…</span>
      </div>
      <div class="ks-allapot hiba" *ngIf="!toltodik && hiba">
        <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
      </div>

      <ng-container *ngIf="!toltodik && !hiba">
        <ion-segment [(ngModel)]="nezet" class="ks-nezet">
          <ion-segment-button value="tetelek"><ion-label>Tételek</ion-label></ion-segment-button>
          <ion-segment-button value="osszesito"><ion-label>Tanulónkénti összesítő</ion-label></ion-segment-button>
        </ion-segment>

        <!-- ══ TÉTELEK ══════════════════════════════════════════════════════ -->
        <ng-container *ngIf="nezet === 'tetelek'">
          <div class="ks-ures" *ngIf="!szurtTetelek.length">
            Nincs rögzített késés erre a szűrésre. A késést a <b>naplóban</b>, a névsor melletti
            perc-mezőben lehet beírni.
          </div>

          <ng-container *ngIf="szurtTetelek.length">
            <div class="ks-muvelet">
              <ion-button size="small" fill="clear" (click)="mind(true)">Mind</ion-button>
              <ion-button size="small" fill="clear" (click)="mind(false)">Egyik sem</ion-button>
              <ion-input class="ks-indok" fill="outline" placeholder="Igazolás indoka (kötelező)"
                         [(ngModel)]="indok"></ion-input>
              <ion-button size="small" color="success" [disabled]="!kijelolt.size || mentesFut"
                          (click)="igazol(true)">
                <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
                Igazolás ({{ kijelolt.size }})
              </ion-button>
              <ion-button size="small" fill="outline" color="medium"
                          [disabled]="!kijelolt.size || mentesFut" (click)="igazol(false)">
                Igazolás visszavonása
              </ion-button>
            </div>

            <div class="ks-tabla-burok">
              <table class="ks-tabla">
                <thead>
                  <tr>
                    <th></th><th>Dátum</th><th>Óra</th><th>Osztály</th><th>Tanuló</th>
                    <th>Tantárgy</th><th class="szam">Késés</th><th>Állapot</th><th>Indok</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let t of szurtTetelek" [class.kijelolve]="kijelolt.has(t.id)">
                    <td><input type="checkbox" [checked]="kijelolt.has(t.id)" (change)="valt(t.id)" [disabled]="t.kezelheti === false"
                               [title]="t.kezelheti === false ? 'Csak megtekintheted: az osztályfőnök, az óra tanára vagy a rögzítő igazolhatja' : ''" /></td>
                    <td>{{ t.datum | date: 'yyyy. MM. dd.' }}</td>
                    <td class="szam">{{ t.oraszam ?? '—' }}</td>
                    <td>{{ t.osztaly_nev || '—' }}</td>
                    <td>{{ t.tanulo_nev }}</td>
                    <td>{{ t.tantargy_nev || '—' }}</td>
                    <td class="szam">{{ t.perc }} perc</td>
                    <td>
                      <span class="jel ok" *ngIf="t.igazolt">igazolt</span>
                      <span class="jel baj" *ngIf="!t.igazolt">igazolatlan</span>
                    </td>
                    <td class="indok" [title]="t.indok || ''">{{ t.indok || '—' }}</td>
                    <td class="muvelet">
                      <ion-button *ngIf="t.kezelheti !== false" size="small" fill="clear" color="danger" (click)="torol(t)">Törlés</ion-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </ng-container>

        <!-- ══ ÖSSZESÍTŐ ════════════════════════════════════════════════════ -->
        <ng-container *ngIf="nezet === 'osszesito'">
          <div class="ks-ures" *ngIf="!szurtOsszesito.length">Ebben a tanévben nincs rögzített késés.</div>
          <div class="ks-tabla-burok" *ngIf="szurtOsszesito.length">
            <table class="ks-tabla">
              <thead>
                <tr>
                  <th>Osztály</th><th>Tanuló</th><th class="szam">Késések</th>
                  <th class="szam">Igazolatlan perc</th><th>Ebből igazolatlan óra</th>
                  <th class="szam">Igazolt perc</th><th>Ebből igazolt óra</th>
                  <th>Következő óráig</th><th>Utolsó</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let t of szurtOsszesito">
                  <td>{{ t.osztaly_nev || '—' }}</td>
                  <td>{{ t.tanulo_nev }}</td>
                  <td class="szam">{{ t.keses_db }}</td>
                  <td class="szam">{{ t.perc_igazolatlan }}</td>
                  <td>
                    <b [class.baj]="t.ora_igazolatlan > 0">{{ t.ora_igazolatlan }} óra</b>
                    <small *ngIf="t.maradek_igazolatlan"> + {{ t.maradek_igazolatlan }} perc</small>
                  </td>
                  <td class="szam">{{ t.perc_igazolt }}</td>
                  <td>{{ t.ora_igazolt }} óra<small *ngIf="t.maradek_igazolt"> + {{ t.maradek_igazolt }} perc</small></td>
                  <td class="halvany">{{ t.kovetkezo_orahoz }} perc</td>
                  <td>{{ t.utolso | date: 'yyyy. MM. dd.' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ion-note color="medium" class="ks-sugo">
            A <b>következő óráig</b> oszlop azt mutatja, hány további igazolatlan perc kell ahhoz, hogy
            a tanulónak újabb igazolatlan órája keletkezzen. A maradék percek nem vesznek el: a következő
            késéssel együtt számítanak tovább.
          </ion-note>
        </ng-container>
      </ng-container>
    </ion-card-content>
  </ion-card>
</ion-content>
